import { studio } from "@/data/site";
import { Reveal, SectionLabel } from "@/components/common/Reveal";

export const Manifesto = () => (
  <section
    className="grain relative overflow-hidden py-24 sm:py-32"
    style={{ background: "var(--ink-2)", borderTop: "1px solid var(--line)" }}
    data-testid="home-manifesto"
  >
    <div className="shell relative">
      <SectionLabel>The studio</SectionLabel>
      <Reveal delay={0.06}>
        <h2 className="font-display mt-6 max-w-2xl text-2xl font-black leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl">
          {studio.tagline}
        </h2>
      </Reveal>

      <div className="mt-16 space-y-0">
        {studio.manifesto.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.08}>
            <div
              className="group grid gap-4 py-10 sm:grid-cols-[auto_1fr] sm:gap-12"
              style={{ borderTop: "1px solid var(--line)" }}
            >
              <span
                className="font-display text-4xl font-black leading-none transition-colors duration-500 sm:text-5xl"
                style={{ color: "rgba(255,255,255,0.12)" }}
              >
                {c.no}
              </span>
              <div className="max-w-2xl">
                <h3 className="font-display text-xl font-bold tracking-tight text-white sm:text-2xl">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-400 sm:text-base">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
